import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { documentTypesTechnicalLibrary } from '@customer/store/apis/documentsApi';
import { setTechLibDocumentTypes } from '@customer/store/slices/filtersSlice';
import { TechLibraryDocumentType } from '@cas/config/documents';

const useDocumentTypeOptions = (): DropdownItemProps<TechLibraryDocumentType>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return documentTypesTechnicalLibrary
      .map((value: TechLibraryDocumentType) => ({
        key: value,
        value,
        stringValue: value,
        label: t(`DocType.${value}`),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [t]);
};

export const TechLibraryDocumentTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<TechLibraryDocumentType>
      filterName="techLibDocumentTypes"
      label={label ?? t('DocumentType')}
      action={setTechLibDocumentTypes}
      elementRef={elementRef}
      useItemsHook={useDocumentTypeOptions}
    />
  );
};

export default TechLibraryDocumentTypesFilter;
